import { create } from "zustand"

export interface ConfirmOptions {
  title: string
  message?: string
  confirmLabel?: string
  cancelLabel?: string
  danger?: boolean
  onConfirm: () => void | Promise<void>
}

interface ConfirmState {
  open: boolean
  busy: boolean
  options: ConfirmOptions | null
  request: (options: ConfirmOptions) => void
  cancel: () => void
  confirm: () => Promise<void>
}

export const useConfirmStore = create<ConfirmState>((set, get) => ({
  open: false,
  busy: false,
  options: null,
  request: (options) => set({ open: true, busy: false, options }),
  cancel: () => set({ open: false, busy: false, options: null }),
  confirm: async () => {
    const { options } = get()
    if (!options) return
    set({ busy: true })
    try {
      await options.onConfirm()
      set({ open: false, busy: false, options: null })
    } catch {
      // Keep the dialog open on failure; the action's own error handling surfaces it.
      set({ busy: false })
    }
  },
}))

/** Imperative helper: `confirmAction({ title, message, onConfirm })`. */
export function confirmAction(options: ConfirmOptions): void {
  useConfirmStore.getState().request(options)
}
